import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { reloadSearchResultAction, VerfahrenSearchKey } from '@schir-int-client/verfahren-shared';
import { VerfahrenGlobalSearchFormService } from './verfahren-global-search.formservice';
import { Actions, ofType } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { DialogService, HandlesBackdropClickAndEscapeKey, NotificationType } from '@schir-int-client/tech';
import { filter, take } from 'rxjs/operators';
import { isNil } from 'lodash-es';
import { ApiRootFacade } from '@schir-int-client/api-root';
import {
	VerfahrenSearchFilterDialogComponent,
	VerfahrenSearchFilterDialogData,
	VerfahrenSearchFilterDialogResult,
} from './verfahren-search-filter-dialog/verfahren-search-filter-dialog.component';

@Component({
	selector: 'schir-int-client-verfahren-global-search',
	templateUrl: './verfahren-global-search.component.html',
	styleUrls: ['./verfahren-global-search.component.scss'],
	standalone: false,
})
export class VerfahrenGlobalSearchComponent
	extends HandlesBackdropClickAndEscapeKey<VerfahrenSearchFilterDialogComponent>
	implements OnInit, OnDestroy
{
	private readonly MISSING_FILTER_MSG =
		'Bitte wählen Sie wenigstens einen Kriterium- und einen Status-Filter für die Suche aus.';

	protected allFiltersSelected = true;
	private subscriptions: Subscription[] = [];
	private searchFields: VerfahrenSearchKey[];

	public constructor(
		private router: Router,
		protected readonly formService: VerfahrenGlobalSearchFormService,
		reloadVerfahrenAction: Actions,
		protected dialogService: DialogService,
		private apiRootFacade: ApiRootFacade,
		private cdr: ChangeDetectorRef
	) {
		super(dialogService);
		this.subscriptions.push(
			reloadVerfahrenAction
				.pipe(
					//TODO subscribe to facade observable?
					ofType(reloadSearchResultAction)
				)
				.subscribe(() => {
					if (this.router.url.startsWith('/verfahren/')) {
						this.reloadCurrentPage();
					} else {
						this.onSearch();
					}
				})
		);
	}

	private reloadCurrentPage(): void {
		const currentUrl = this.router.url;
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate([currentUrl.split('(')[0]]);
		});
	}

	public ngOnInit(): void {
		this.subscriptions.push(
			this.formService.allFiltersSelected.subscribe(value => {
				this.allFiltersSelected = value;
				this.cdr.markForCheck();
			})
		);
		this.subscriptions.push(
			this.apiRootFacade
				.getCurrentApiRoot()
				.pipe(filter(apiRoot => !isNil(apiRoot)))
				.subscribe(apiRoot => {
					this.searchFields = apiRoot.features.searchableFields;
				})
		);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(s => s.unsubscribe());
	}

	protected onSearch(): void {
		if (this.formService.enoughFiltersSelected()) {
			this.formService.onSubmit();
			this.router.navigate(['verfahren']);
		} else {
			this.dialogService.openAcknowledgeDialog(this.MISSING_FILTER_MSG, NotificationType.INFO);
		}
	}

	protected openFilterDialog(): void {
		this.matDialogRef = this.dialogService.openDialog(VerfahrenSearchFilterDialogComponent, {
			disableClose: true,
			data: <VerfahrenSearchFilterDialogData>{
				searchFields: this.searchFields,
				selectedSearchFields: this.formService.getSearchFieldFilters(),
				selectedStatus: this.formService.getStatusFilters(),
			},
		});
		this.preventCloseOfDirtyForm();
		this.subscriptions.push(
			this.matDialogRef.componentInstance.doApplyFilters
				.pipe(take(1))
				.subscribe((result: VerfahrenSearchFilterDialogResult) => {
					this.formService.setSearchFieldFilters(result.searchFields);
					this.formService.setStatusFilters(result.status);
					this.onSearch();
				})
		);
	}

	protected hiddenFeature($event: MouseEvent = null): void {
		if ($event?.ctrlKey && $event?.altKey) {
			this.formService.exportRegister();
		}
	}
}
